import React from 'react'
import './school-select.scss'
import { Constants, ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import Loading from '../../common/loading/loading'
import SchoolApi from '../../../apis/school'
import PaginationComponent from "../../common/cw-pagination/cw-pagination"
import Path from '../../routes/routes-path';

import SessionCache from '../../routes/session-cache';

class SchoolSignupComponent extends React.Component {
  state = {
    filter: {},
    schools: []
  }
  limit = 10
  currentPage = 1

  componentDidMount() {
    let user = SessionCache.getUser()
    this.setState({ user })
    this.getSchools()
  }

  getSchools(filters = {}) {
    let payload = { ...filters }
    if (!payload.limit) payload.limit = this.limit
    if (!payload.page) payload.page = this.currentPage


    this.currentPage = payload.page
    if (this.currentPage === 1) this.startIndex = 1

    SchoolApi.getSchoolWithPagination(payload).then(response => {
      this.setState({ schools: response.response, meta: response.meta })
    }).catch(err => {
      console.log("Error", err)
    })
  }

  onChangeHandler(e, key) {
    let value = e.target.value
    let filter = this.state.filter
    filter[key] = value
    this.setState({ filter }, () => {
      if (!value || value.length >= 3) {
        this.getSchools({ ...filter, page: 1 })
      }
    })

  }

  onClickContinue(school) {

    let payload = {
      schoolId: school.schoolCode
    }

    console.log(payload)

    SchoolApi.updateSuperAdminSchool(payload)
      .then(data => {
        let user = SessionCache.getUser()
        user.schoolInfo = data?.data || {}
        SessionCache.setUser(user)

        this.props.history.replace(Path.DASHBOARD)
      })
      .catch(err => {
        this.setState({
          boardDropdownLoading: false
        })
      })
  }

  onPageSelected(page, startIndex) {

    this.currentPage = page;
    this.startIndex = startIndex

    this.getSchools(this.state.filter);
  }

  onClickBack = () => {
    this.props.history.push(Path.DASHBOARD)
  }

  render() {
    return (
      <>
        {this.state.loading && <Loading />}
        <div className='container-fluid school-select'>
          <div className='header row no-gutters'>
            <div className='col-6'>
              <a href='https://countingwell.com'>
                <img alt='' className='logo' src={getImageSource(ImageConstants.CW_LOGO)} />
              </a>
            </div>
          </div>

          <div className="p-4">

            {
              this.state.user?.schoolInfo?.schoolCode ?
                <div>
                  <img src={getImageSource(ImageConstants.BACK_ICON)} className='icon-20 cursor-pointer' onClick={this.onClickBack} />
                </div> : ""
            }

            <div className='row pt-4'>
              <div className='col-2'>
                <div className='filter-input-label pb-2'>Name</div>
                <input
                  className='cw-input search-input'
                  placeholder='Search By Name and Code'
                  onChange={e => this.onChangeHandler(e, 'search')}
                  value={this.state.filter?.search}
                />
              </div>
              <div className='col-2'>
                <div className='filter-input-label pb-2'>Branch</div>
                <input
                  className='cw-input search-input'
                  placeholder='Search By Branch'
                  onChange={e => this.onChangeHandler(e, 'branchSearch')}
                  value={this.state.filter?.branchSearch}
                />
              </div>
              <div className='col-2'>
                <div className='filter-input-label pb-2'>City</div>
                <input
                  className='cw-input search-input'
                  placeholder='Search By City'
                  onChange={e => this.onChangeHandler(e, 'citySearch')}
                  value={this.state.filter?.citySearch}
                />
              </div>
            </div>

            <div id="table-scoll" className="table-responsive mt-5">
              <table className="table cw-table mb-0 align-items-center">
                <thead>
                  <tr>
                    <th className='th-left-radius'>School</th>
                    <th className=''>School Code</th>
                    <th className=''>Branch</th>
                    <th className=''>City</th>
                    <th className='th-right-radius'></th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {
                    this.state.schools?.length ? this.state.schools?.map((item, index) => (
                      <tr key={item.schoolCode} className="mt-4">
                        <td>{item.name}</td>
                        <td>{item?.schoolCode}</td>
                        <td>{item?.address?.branch}</td>
                        <td>{item?.address?.city}</td>
                        <td className="text-right"><span className="continue-button px-5 py-2 cursor-pointer" onClick={() => this.onClickContinue(item)}>Continue</span></td>
                      </tr>
                    ))
                      : <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Records found</td></tr>
                  }
                </tbody>
              </table>
            </div >
            <div className='card-footer'>
              {
                this.state.meta?.totalPages ? <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta?.totalPages} onPageSelected={this.onPageSelected.bind(this)} /> : ""
              }
            </div>
          </div>

        </div>
      </>
    )
  }
}

export default SchoolSignupComponent
